/**
 * Zentrale Konstanten für strukturierte Daten (schema.org).
 *
 * `SITE_URL` ist bewusst die www-Variante – so ist die Website im Code an allen
 * Stellen konsistent (Canonical, og:url, og:image, @id), siehe Kanonisierungs-
 * Entscheidung in `00-gemeinsame-entscheidungen.md`.
 *
 * `PERSON_ROLF_ID` ist die kanonische Person-@id, die the-stack.dev und
 * web-professionals.ch bewusst teilen (siehe P5 im LLM-Optimierungs-Task). Ein
 * späterer Wechsel dieser @id verwirft das Entitäts-Signal – nicht ändern, ohne
 * das Gegenstück auf the-stack.dev anzupassen.
 */
export const SITE_URL = 'https://www.web-professionals.ch'
export const ORGANIZATION_ID = `${SITE_URL}/#organization`
export const WEBSITE_ID = `${SITE_URL}/#website`
export const PERSON_ROLF_ID = `${SITE_URL}/ueber-uns/dozenten/rolf-eggenberger#person`

/**
 * EducationalOrganization-Node, referenziert von allen Unterseiten über `@id`.
 * Die Gesellschaftsbeziehung zu the Stack wird hier bewusst NICHT abgebildet
 * (kein `sameAs`/`parentOrganization` zu the-stack.dev) – siehe Entscheidung in
 * `00-gemeinsame-entscheidungen.md`. Verbunden wird ausschliesslich über die Person.
 */
export function organizationNode() {
  return {
    '@type': 'EducationalOrganization',
    '@id': ORGANIZATION_ID,
    'name': 'Web Professionals',
    'legalName': 'Web Professionals GmbH',
    'url': SITE_URL,
    'logo': `${SITE_URL}/webpro.svg`,
    'foundingDate': '2013',
    'email': 'hello@web-professionals.ch',
    'areaServed': ['Ostschweiz', 'Rheintal', 'Liechtenstein'],
    // Nur Grabs ist ein echter Standort. St. Gallen ist laut FAQ ein wechselnder
    // Mietraum (mal Liip AG Neumarkt, mal Startfeld) – als `location` der
    // Organisation ausgezeichnet wäre das eine Niederlassung, die es nicht gibt,
    // plus die Adresse einer fremden Firma (siehe „W4" in
    // docs/offene-punkte-webpro-llm.md). Der Ort gehört stattdessen an die
    // einzelne `CourseInstance`, und auch dort nur, wenn er für den Termin feststeht.
    'address': {
      '@type': 'PostalAddress',
      'streetAddress': 'Staudnerbachstrasse 8',
      'postalCode': '9472',
      'addressLocality': 'Grabs',
      'addressRegion': 'Sankt Gallen',
      'addressCountry': 'CH'
    },
    'sameAs': [
      'https://www.youtube.com/channel/UCqBw30GcrJDms54l1g4CAWQ'
    ]
  }
}

export function websiteNode() {
  return {
    '@type': 'WebSite',
    '@id': WEBSITE_ID,
    'name': 'Web Professionals',
    'url': SITE_URL,
    'inLanguage': 'de-CH',
    'publisher': { '@id': ORGANIZATION_ID }
  }
}

/** Absolute URL aus einem Content-Pfad (z. B. `/blog/mein-post`). */
export function absoluteUrl(path: string): string {
  return `${SITE_URL}${path.startsWith('/') ? path : `/${path}`}`
}
